export const RESET_PHARMACY_STATE = "RESET_PHARMACY_STATE";

export const START_GET_PHARMACIES_LIST = "START_GET_PHARMACIES_LIST";
export const SUCCESS_GET_PHARMACIES_LIST = "SUCCESS_GET_PHARMACIES_LIST";
export const ERROR_GET_PHARMACIES_LIST = "ERROR_GET_PHARMACIES_LIST";

export const START_CREATE_PHARMACY = "START_CREATE_PHARMACY";
export const SUCCESS_CREATE_PHARMACY = "SUCCESS_CREATE_PHARMACY";
export const ERROR_CREATE_PHARMACY = "ERROR_CREATE_PHARMACY";

export const START_UPDATE_PHARMACY = "START_UPDATE_PHARMACY";
export const SUCCESS_UPDATE_PHARMACY = "SUCCESS_UPDATE_PHARMACY";
export const ERROR_UPDATE_PHARMACY = "ERROR_UPDATE_PHARMACY";

export const START_DELETE_PHARMACY = "START_DELETE_PHARMACY";
export const SUCCESS_DELETE_PHARMACY = "SUCCESS_DELETE_PHARMACY";
export const ERROR_DELETE_PHARMACY = "ERROR_DELETE_PHARMACY";

export const SET_HEADER_FILTER_PHARMACIES = "SET_HEADER_FILTER_PHARMACIES";
